import { useState } from 'react';
import API_URL from "../API";
import { motion } from "motion/react";
import { FaArrowRight, FaCheckCircle, FaFingerprint } from "react-icons/fa";
import Swal from "sweetalert2";
import '../Attendance/Attendance.css';
import Logo from '../Assets/Logo_PrioritasMember-07.png';
import wefLogo from "../Assets/wef-detective-logo.png";
import mascot from "../Assets/wef-detective-mascot.png";
import heroVideo from "../Assets/wef-back-sep-2026.webm";

const Attendance = () => {
  const [idEvent] = useState(API_URL.id_event);
  const [codeRegister, setCodeRegister] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append('id_event', idEvent);
    formData.append('code_register', codeRegister);
    formData.append('status', 1);
    setIsSubmitting(true);

    API_URL.eventUrl
      .post('world-education-festival/attandance', formData)
      .then(response => {
        if (response.data.message === 'Attandance Member') {
          Swal.fire({
            imageUrl: Logo,
            imageWidth: 450,
            imageHeight: 150,
            imageAlt: "Logo Prioritas Member",
            title: "Register Berhasil"
          }).then(result => {
            if (result.isConfirmed) window.location.reload();
          });
        } else {
          Swal.fire({
            title: "Register Berhasil",
            icon: 'success',
          }).then(result => {
            if (result.isConfirmed) window.location.reload();
          });
        }
      })
      .catch(() => {
        Swal.fire({
          title: "Register Gagal",
          icon: 'error',
        }).then(result => {
          if (result.isConfirmed) window.location.reload();
        });
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <div className="detective-subpage attendance-page">
      <div className="attendance-hero-bg">
        <video
          className="attendance-hero-bg-video"
          src={heroVideo}
          autoPlay
          muted
          playsInline
          preload="auto"
        />
        <div className="attendance-hero-bg-gradient" />
      </div>
      <a className="subpage-brand" href="/" aria-label="Kembali ke World Education Festival">
        <img src={wefLogo} alt="World Education Festival" />
      </a>

      <main className="attendance-content">
        <motion.section
          className="attendance-case-file"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65 }}
        >
          <p className="subpage-eyebrow"><FaFingerprint /> Guest verification</p>
          <h1>Check In WEF 2026</h1>
          <p className="attendance-intro">Scan barcode atau masukkan kode registrasi untuk mencatat kehadiranmu dan membuka akses ke area World Education Festival.</p>

          <form className="attendance-form" onSubmit={handleSubmit}>
            <label htmlFor="code_register">Kode Registrasi</label>
            <input
              id="code_register"
              type="text"
              name="code_register"
              autoFocus
              required
              autoComplete="off"
              placeholder="Contoh: EV00014934"
              value={codeRegister}
              onChange={(e) => setCodeRegister(e.target.value)}
            />
            <button type="submit" disabled={isSubmitting || !codeRegister.trim()}>
              {isSubmitting ? "Memeriksa kode…" : <>Konfirmasi Kehadiran <FaArrowRight /></>}
            </button>
          </form>

          <p className="attendance-hint"><FaCheckCircle /> Pastikan QR/code registrasi .</p>
        </motion.section>
        <img className="attendance-mascot" src={mascot} alt="Detektif WEF" />
      </main>
    </div>
  );
};

export default Attendance;
